import { useMutation, useQueryClient } from '@tanstack/react-query';

import { NotificationKey } from '#notification/keys';

import { PostService } from './postService';

/**
 * Marks posts as read by the current user. The backend also marks their post
 * notifications as read, so the notification caches are refreshed afterwards.
 */
export function useMarkPostsRead() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: number[]) => PostService.markPostsRead(ids).then((response) => response.data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [NotificationKey.NOTIFICATIONS_INFINITE] });
      void queryClient.invalidateQueries({ queryKey: [NotificationKey.UNREAD_NOTIFICATIONS_COUNT] });
    },
  });
}
